import Rest from '@services/Rest'

/**
 * @typedef {CashbackMetaService}
 */
export default class CashbackMetaService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/metas-cashback'
}
